import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ENVIRONMENT } from '@cfp/core';
import { isBsatRegistrationClosed } from '../bsat-registration-closed';
import { SelfOnboardingLayout } from '../self-onboarding-layout';
import { SelfOnboardingRegistrationClosed } from '../self-onboarding-registration-closed';
import { SelfOnboardingVerifyAccount } from '../self-onboarding-verify-account';

@Component({
  selector: 'cfp-self-onboarding-verify-account-page',
  templateUrl: './self-onboarding-verify-account-page.html',
  imports: [SelfOnboardingVerifyAccount, SelfOnboardingLayout, SelfOnboardingRegistrationClosed],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelfOnboardingVerifyAccountPage {
  private readonly environment = inject(ENVIRONMENT);

  protected readonly isRegistrationClosed = isBsatRegistrationClosed(this.environment.environmentCode.dto);
}
